// Module
var code = "<template> <section> <div class=\"ess-grid\"> <ess-text class=\"ess-col-6\" value.bind=\"textValue\" label=\"Text Content\" required=\"true\"></ess-text> </div> </section> </template> ";
// Exports
module.exports = code;